export const SAVE_DATABASE_CONFIG_REQUEST = "SAVE_DATABASE_CONFIG_REQUEST";
export const SAVE_DATABASE_CONFIG_SUCCESS = "SAVE_DATABASE_CONFIG_SUCCESS";
export const SAVE_DATABASE_CONFIG_FAILURE = "SAVE_DATABASE_CONFIG_FAILURE";
